import React from "react";
import "./loader.css";

const Loader = ({ show = true, fullscreen = true, text, size = 16 }) => {
  if (!show) return null;
  return (
    <div className={fullscreen ? "loader-overlay" : "loader-inline"}>
      <div className="loader" style={{ "--dot-size": `${size}px` }}>
        <span className="loader-dot" />
        <span className="loader-dot" />
        <span className="loader-dot" />
      </div>
      {text && <p className="loader-text">{text}</p>}
    </div>
  );
};


export default Loader;
